<template>
  <div class="login-container">
    <div class="login-bg"></div>
    <div class="login-box">
      <div class="login-header">
        <img class="login-logo" src="../../assets/logo.png" alt="logo">
        <h1 class="login-title">{{ projectName }}</h1>
        <p class="login-subtitle">后台管理系统</p>
      </div>
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" status-icon>
        <el-form-item prop="userName">
          <el-input v-model="dataForm.userName" size="large" prefix-icon="el-icon-user" placeholder="请输入帐号" clearable></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="dataForm.password" size="large" prefix-icon="el-icon-lock" type="password" show-password placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item prop="captcha">
          <div class="captcha-row">
            <div class="captcha-input">
              <el-input v-model="dataForm.captcha" size="large" prefix-icon="el-icon-key" placeholder="请输入验证码"></el-input>
            </div>
            <img class="captcha-img" :src="captchaPath" @click="getCaptcha()" alt="验证码" title="点击刷新验证码">
          </div>
        </el-form-item>
        <el-form-item>
          <el-button class="login-btn" type="primary" size="large" :loading="loginLoading" @click="dataFormSubmit()">登 录</el-button>
        </el-form-item>
      </el-form>
      <p class="login-footer">Copyright © 中国热科院品资所</p>
    </div>
  </div>
</template>

<script>
  import config from '@/config'
  import { getUUID } from '@/utils'
  export default {
    data () {
      return {
        projectName: config.projectName,
        dataForm: {
          userName: '',
          password: '',
          uuid: '',
          captcha: ''
        },
        dataRule: {
          userName: [
            { required: true, message: '帐号不能为空', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '密码不能为空', trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: '验证码不能为空', trigger: 'blur' }
          ]
        },
        captchaPath: '',
        loginLoading: false
      }
    },
    created () {
      this.getCaptcha()
    },
    methods: {
      // 提交表单
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.loginLoading = true
            this.$http({
              url: this.$http.adornUrl('/sys/login'),
              method: 'post',
              data: this.$http.adornData({
                'username': this.dataForm.userName,
                'password': this.dataForm.password,
                'uuid': this.dataForm.uuid,
                'captcha': this.dataForm.captcha
              })
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$cookie.set('token', data.token)
                this.$router.push({ name: 'home', replace: true })
              } else {
                this.loginLoading = false
                this.getCaptcha()
                this.$message.error(data.msg)
              }
            }).catch(() => {
              this.loginLoading = false
            })
          }
        })
      },
      // 获取验证码
      getCaptcha () {
        this.dataForm.uuid = getUUID()
        this.captchaPath = this.$http.adornUrl(`/captcha.jpg?uuid=${this.dataForm.uuid}`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: linear-gradient(135deg, #1f6f54 0%, #2e8b6f 45%, #0f9d76 100%);
  }
  .login-bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url(~@/assets/img/login_bg.jpg);
    background-size: cover;
    background-position: center;
    opacity: .2;
  }
  .login-box {
    position: relative;
    z-index: 1;
    width: 460px;
    max-width: calc(100vw - 40px);
    padding: 40px 40px 26px;
    border-radius: 14px;
    background: rgba(255, 255, 255, .98);
    box-shadow: 0 18px 50px rgba(0, 0, 0, .28);
    overflow: hidden;
    animation: loginFadeIn .45s ease;
  }
  .login-header {
    margin-bottom: 28px;
    text-align: center;
  }
  .login-logo {
    width: 60px;
    height: 60px;
    object-fit: contain;
  }
  .login-title {
    margin: 14px 0 8px;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
    color: #1f2d3d;
  }
  .login-subtitle {
    margin: 0;
    font-size: 13px;
    letter-spacing: 4px;
    color: #909399;
  }
  // 输入项上下间距（使用深度选择器，确保命中 Element 组件根元素）
  .login-box ::v-deep .el-form-item {
    margin-bottom: 24px !important;
  }
  .login-box ::v-deep .el-form-item:last-child {
    margin-bottom: 0 !important;
  }
  // 所有输入框占满整行
  .login-box ::v-deep .el-input {
    width: 100% !important;
  }
  .login-box ::v-deep .el-form,
  .login-box ::v-deep .el-form-item,
  .login-box ::v-deep .el-form-item__content {
    width: 100% !important;
  }
  // 验证码：输入框自适应，图片固定宽度，整行宽度与其它输入框一致
  .captcha-row {
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
  }
  .captcha-input {
    flex: 1 1 auto;
    min-width: 0;
  }
  .captcha-img {
    flex: 0 0 130px;
    width: 130px;
    min-width: 130px;
    max-width: 130px;
    height: 40px;
    margin-left: 12px;
    padding: 2px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    background-color: #fff;
    box-sizing: border-box;
    cursor: pointer;
    object-fit: contain;
  }
  .login-btn {
    width: 100%;
    letter-spacing: 6px;
  }
  .login-footer {
    margin: 20px 0 0;
    text-align: center;
    font-size: 12px;
    color: #c0c4cc;
  }
  @keyframes loginFadeIn {
    from {
      opacity: 0;
      transform: translateY(16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
